import { useCallback } from 'react';

import * as Types from './types';
import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';

export const useDocumentUploadStatusListener = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IUseDocumentUploadStatusListenerRequestData) => {
        const { data } = await send<Types.IUseDocumentUploadStatusListenerRequestData, TServerSendResponse>({
            ID: 35723,
            responses: [35724, 35725],
            description: 'Document Upload Status Listener',
            ...request
        });

        return data;
    }, [send]);
};
